// eslint-disable-next-line no-unused-vars
import { MatchCentreState } from './modules/match-centre/types';
import { BrownlowTrackerState } from './modules/brownlow-tracker/types';

/**
 * @typedef {object} ReduxState
 * @property {{[key: string]: object, list: object[]}} rounds
 * @property {MatchCentreState} matchCentre
 * @property {BrownlowTrackerState} brownlowTracker
 */

/**
 * @typedef {( any ) => Action} ActionCreator
 */

/**
 * @typedef {object} SignalActionObject
 * @property {string} REQUEST
 * @property {string} SUCCESS
 * @property {string} FAILURE
 * @property {ActionCreator} request
 * @property {ActionCreator} success
 * @property {ActionCreator} failure
 */

/**
 * @typedef {object} Action
 * @property {string} type
 * @property {any} payload
 */
